  <script setup>
  import ButtonSubmit from "./ButtonSubmit.vue";
  import api from "../api/api";
  import HomeViewSampleReport from "./HomeViewSampleReport.vue";
  </script>
  <template>
    <div class="main-div">
      <div
        class="bg-main-color1"
        style="
          padding: 10px;
          color: #fff;
          display: flex;
          justify-content: space-between;
        "
      >
        <div>
          <strong>{{ label }}</strong>
          <span v-if="filterBreadcrumb" style="font-weight: normal; opacity: 0.9;"> - {{ filterBreadcrumb }}</span>
        </div>
        <button
          class="bg-main-color1"
          style="color: #fff"
          @click.prevent="toggle = !toggle"
          v-show="!toggle"
        >
          Show
        </button>
        <button
          class="bg-main-color1"
          style="color: #fff"
          @click.prevent="toggle = !toggle"
          v-show="toggle"
        >
          Hide
        </button>
      </div>
      <div
        class="parent"
        v-show="toggle"
        v-if="filteredAllReports.length == 0"
      >
        <h2>No faculty report(s) available.</h2>
      </div>
      <div class="parent" v-show="toggle" v-if="filteredAllReports.length > 0">
        <div
          class="child"
          style="background-color: #cdcdcd"
          v-for="report in paginatedReports"
          :key="report"
        >
          <div>
            <p>{{ report.program_name }}</p>
            <h2>{{ report.iteration_name }}</h2>
            <h2>{{ report.report_template_name }}</h2>
          </div>
          <div v-if="report.survey_type == 1">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/big5_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 2">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/360_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 3">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/research_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 7">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/tipping_point_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 8">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/pressure_point_logo.png"
            />
          </div>

          <!--Team Leader 360-->
          <a
            v-if="report.report_file == 'TeamLeader360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'TeamLeader360Report.html',
                14850,
                'Sample User',
                38,
                61,
                1,
                17,
                31
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'TeamLeader360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'TeamLeader360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--General Manager 360-->
          <a
            v-if="report.report_file == 'GeneralManager360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'GeneralManager360Report.html',
                14846,
                'Sample User',
                38,
                60,
                1,
                17,
                25
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'GeneralManager360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'GeneralManager360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Alba 360-->
          <a
            v-if="report.report_file == 'ALBATeamLeader360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'ALBATeamLeader360FacultyReport.html',
                14846,
                'Sample User',
                38,
                60,
                1,
                17,
                25
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'ALBATeamLeader360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'ALBATeamLeader360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />
          
          <a
            v-if="report.report_file == 'ALBAGeneralManager360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'ALBAGeneralManager360FacultyReport.html',
                14846,
                'Sample User',
                38,
                60,
                1,
                17,
                25
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'ALBAGeneralManager360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'ALBAGeneralManager360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--SEP 360 report-->
          <a
            v-if="report.report_file == 'SeniorExecProgram360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'SeniorExecProgram360Report.html',
                14848,
                'Sample User',
                38,
                63,
                1,
                17,
                27
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'SeniorExecProgram360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'SeniorExecProgram360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--TalentSage 360 report-->
          <a
            v-if="report.report_file == 'TalentSage360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'TalentSage360Report.html',
                14849,
                'Sample User',
                38,
                59,
                1,
                17,
                29
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'TalentSage360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'TalentSage360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--HELP 360 report-->
          <a
            v-if="report.report_file == 'HELP360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'HELP360Report.html',
                14847,
                'Sample User',
                38,
                62,
                1,
                17,
                33
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'HELP360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'HELP360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--EuroNav360-->
          <a
            v-if="report.report_file == 'EURONAV360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'EURONAV360Report.html',
                survey_assignment_id,
                'Sample User',
                38,
                61,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'EURONAV360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'EURONAV360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Big five or Big 5 view report button-->
          <a
            v-if="report.report_file == '5StepFacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                '5Step.html',
                14845,
                'Sample User',
                38,
                64,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == '5StepFacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == '5StepFacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Tipping Point report-->
          <a
            v-if="report.report_file == 'TIPpingPointFacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'TIPpingPointReport.html',
                14845,
                'Sample User',
                38,
                64,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'TIPpingPointFacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'TIPpingPointFacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Pressure Point report-->
          <a
            v-if="report.report_file == 'PressurePointFacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'PressurePointReport.html',
                14845,
                'Sample User',
                38,
                64,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'PressurePointFacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'PressurePointFacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <div
            class="tooltip"
            v-if="facultyOrg && facultySuborg"
            style="margin-top: 10px"
          >
            Information
            <span class="tooltiptext"
              >- Above this tooltip shows exactly what the coach see in their
              report tile screen.
              <br />
              <br />- This tooltip and the button under this only shows for Admin
              to view the report.</span
            >
          </div>

          <a
            class="btn-submit"
            v-if="facultyOrg && facultySuborg"
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >Admin access to report</a>
        </div>
      </div>

      <div v-if="filteredAllReports.length > 0 && totalPages > 1" class="pagination-container">
        <button 
          class="pagination-btn" 
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <button 
          v-for="page in displayedPages" 
          :key="page"
          class="pagination-btn"
          :class="{ 'active': page === currentPage }"
          @click="goToPage(page)">
          {{ page }}
        </button>
        
        <button 
          class="pagination-btn" 
          :disabled="currentPage === totalPages"
          @click="goToPage(currentPage + 1)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        
        <div class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }} 
          <span v-if="activeFilters">({{ filteredAllReports.length }} filtered / {{ allReports.length }} total)</span>
          <span v-else>({{ allReports.length }} total reports)</span>
        </div>
      </div>

      <HomeViewSampleReport
        v-if="showFacultySampleModal == true"
        @close-modal="showFacultySampleModal = false"
        :surveyAssignmentId="survey_assignment_id"
        :suborg="suborg_id"
        :surveyTemplateId="survey_template_id"
        :programId="program_id"
        :iterationId="iteration_id"
        :orgId="org_id"
        :suborgName="suborg_name"
        :programName="program_name"
        :iterationName="iteration_name"
        :reportForFullName="report_for_fullname"
        :viewerFullName="viewer_fullname"
        :reportLink="report_link"
        :brandData="brandData"
        :userData="userData"
      />
    </div>
  </template>
  <script>
  export default {
    components: [ButtonSubmit, HomeViewSampleReport],
    name: "HomeFacultyReport",
    data: () => ({
      toggle: true,
      reportData: [],
      facultyIteration: "",
      joinSuborg: "",
      showFacultySampleModal: false,
      report_link: "",
      org_id: "",
      suborg_id: "",
      survey_template_id: "",
      program_id: "",
      iteration_id: "",
      suborg_name: "",
      program_name: "",
      iteration_name: "",
      report_for_fullname: "",
      survey_assignment_id: 0,
      viewer_fullname: "",
      currentPage: 1,
      itemsPerPage: 10,
    }),
    watch: {
      activeFilters: {
        handler() {
          this.currentPage = 1;
        },
        deep: true
      }
    },
    async mounted() {
      if (this.facultyOrg && this.facultySuborg) {
        await api
          .get(`get-faculty-reports/${this.facultyOrg}/${this.facultySuborg}`)
          .then((res) => {
            this.reportData = res.data;
          });
      } else {
        var array = this.userData.suborgs.split(",");
        this.joinSuborg = array.join(",");

        await api
          .get(`get-faculty-reports/${this.userData.org_id}/${this.joinSuborg}`)
          .then((res) => {
            this.reportData = res.data;
          });
      }
    },
    props: [
      "userData",
      "brandData",
      "reportName",
      "surveyName",
      "dateTime",
      "buttonLabel",
      "label",
      "buttonColor",
      "facultyOrg",
      "facultySuborg",
      "activeFilters",
    ],

    methods: {
      goToPage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          const parentDiv = this.$el.querySelector('.parent');
          if (parentDiv) {
            parentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      },
      myReport(
        report_suborg_name,
        report_program_name,
        report_iteration_name,
        report_file,
        report_program_id,
        report_iteration_id,
        report_org_id,
        report_suborg_id,
        report_survey_template_id
      ) {
        // get sex and country first
        let data;

        data = {
          report_link: this.brandData.website_url + report_file,
          report_for_fullname:
            this.userData.first_name + " " + this.userData.last_name,
          org_id: report_org_id,
          suborg_id: report_suborg_id,
          program_id: report_program_id,
          iteration_id: report_iteration_id,
          survey_template_id: report_survey_template_id,
          ind_id: this.userData.ind_id,
          suborg_name: report_suborg_name,
          program_name: report_program_name,
          iteration_name: report_iteration_name,
        };
        this.$router.push({
          name: "MyReport",
          params: { data: JSON.stringify(data) },
        });
      },

      showFacultySampleReport(
        report_file,
        survey_assignment_id,
        full_name,
        program_id,
        iteration_id,
        org_id,
        suborg_id,
        survey_template_id
      ) {
        this.showFacultySampleModal = true;
        this.viewer_fullname =
          this.userData.first_name + " " + this.userData.last_name;
        this.report_for_fullname = full_name;
        this.report_link = this.brandData.website_url + report_file;
        this.suborg_id = suborg_id;
        this.survey_template_id = survey_template_id;
        this.program_id = program_id;
        this.iteration_id = iteration_id;
        this.org_id = org_id;
        this.survey_assignment_id = survey_assignment_id;
      },
    },

    computed: {
      filterBreadcrumb() {
        if (!this.activeFilters) {
          return '';
        }

        const parts = [];
        
        // Organization
        if (this.activeFilters.organization) {
          parts.push(this.activeFilters.organization.name);
          
          // Sub-Organization
          if (this.activeFilters.subOrganization) {
            parts.push(this.activeFilters.subOrganization.name);
            
            // Program
            if (this.activeFilters.program) {
              parts.push(this.activeFilters.program.name);
              
              // Iteration
              if (this.activeFilters.iteration) {
                parts.push(this.activeFilters.iteration.name);
                
                // Stream
                if (this.activeFilters.stream) {
                  parts.push(this.activeFilters.stream.name);
                  
                  // Group
                  if (this.activeFilters.group) {
                    parts.push(this.activeFilters.group.name);
                  } else {
                    const groupCount = this.activeFilters.stream.groups?.length || 0;
                    if (groupCount > 1) {
                      parts.push('many');
                    }
                  }
                } else {
                  const streamCount = this.activeFilters.iteration.streams?.length || 0;
                  if (streamCount > 1) {
                    parts.push('many');
                  }
                }
              } else {
                const iterationCount = this.activeFilters.program.iterations?.length || 0;
                if (iterationCount > 1) {
                  parts.push('many');
                }
              }
            } else {
              const programCount = this.activeFilters.subOrganization.programs?.length || 0;
              if (programCount > 1) {
                parts.push('many');
              }
            }
          } else {
            const subOrgCount = this.activeFilters.organization.subOrgs?.length || 0;
            if (subOrgCount > 1) {
              parts.push('many');
            }
          }
        }
        
        return parts.join(' / ');
      },

      applyFiltersToReports() {
        return (reports) => {
          if (!this.activeFilters) return reports;

          return reports.filter(report => {
            if (this.activeFilters.organization && report.org_id !== this.activeFilters.organization.id) return false;
            if (this.activeFilters.subOrganization && report.suborg_id !== this.activeFilters.subOrganization.id) return false;
            if (this.activeFilters.program && report.program_id !== this.activeFilters.program.id) return false;
            if (this.activeFilters.iteration && report.iteration_id !== this.activeFilters.iteration.id) return false;
            if (this.activeFilters.stream && report.stream_id !== this.activeFilters.stream.id) return false;
            if (this.activeFilters.group && report.group_id !== this.activeFilters.group.id) return false;

            if (this.activeFilters.searchQuery) {
              const query = this.activeFilters.searchQuery.toLowerCase();
              const programName = report.program_name?.toLowerCase() || '';
              const iterationName = report.iteration_name?.toLowerCase() || '';
              const reportName = report.report_template_name?.toLowerCase() || '';
              const suborgName = report.suborg_name?.toLowerCase() || '';
              
              if (!programName.includes(query) && !iterationName.includes(query) && 
                  !reportName.includes(query) && !suborgName.includes(query)) {
                return false;
              }
            }
            return true;
          });
        };
      },

      allReports: function () {
        return this.reportData.sort((a, b) =>
          a.report_template_name.localeCompare(b.report_template_name)
        );
      },

      filteredAllReports() {
        return this.applyFiltersToReports(this.allReports);
      },

      totalPages() {
        return Math.ceil(this.filteredAllReports.length / this.itemsPerPage);
      },

      paginatedReports() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredAllReports.slice(start, end);
      },

      displayedPages() {
        const pages = [];
        const maxVisible = 5;
        
        if (this.totalPages <= maxVisible) {
          for (let i = 1; i <= this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          if (this.currentPage <= 3) {
            for (let i = 1; i <= 4; i++) {
              pages.push(i);
            }
            pages.push('...');
            pages.push(this.totalPages);
          } else if (this.currentPage >= this.totalPages - 2) {
            pages.push(1);
            pages.push('...');
            for (let i = this.totalPages - 3; i <= this.totalPages; i++) {
              pages.push(i);
            }
          } else {
            pages.push(1);
            pages.push('...');
            pages.push(this.currentPage - 1);
            pages.push(this.currentPage);
            pages.push(this.currentPage + 1);
            pages.push('...');
            pages.push(this.totalPages);
          }
        }
        
        return pages;
      },
    },
  };
  </script>

  <style scoped>
  .main-div {
    min-width: 75vw;
    margin: 15px;
  }
  h4 {
    margin: 0;
  }
  .label-btn {
    color: #fff;
    background-color: #0e5071;
  }
  .parent {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px 0 10px;
    padding-bottom: 30px;
    margin-top: 20px;
    border: 2px solid transparent;
    border-radius: 20px;
    box-shadow: 0px 2px 10px -4px #000000;
  }
  .parent:hover {
    border-style: inset;
    border: 2px solid #888;
  }
  .child {
      border: 1px solid #888;
      border-radius: 10px;
      border-top: 6px solid #0e5071;
      text-align: center;
      font: -webkit-control;
      width: 250px;
      min-width: 250px;
      min-height: 400px;
      margin: 0 10px;
      padding: 10px;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-shadow: 2px 4px #ccc;
    }
  .child:hover {
    border-radius: 2px;
    box-shadow: 5px 8px #ccc;
    transition: all 300ms ease;
  }
  .child-submitted {
    border: 1px solid #888;
    border-top: 6px solid #54575b;
    text-align: center;
    font: -webkit-control;
    min-width: 205px;
    max-width: 205px;
    margin: 0 10px;
    padding: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 2px 4px #ccc;
  }
  .child-submitted:hover {
    border-radius: 2px;
    box-shadow: 5px 8px #ccc;
    transition: all 300ms ease;
  }
  .surveyLogo {
    width: 150px;
    height: auto;
  }
  .btn-submit {
    text-decoration: none;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
    color: #888;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 10px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .sample-report-href {
    text-decoration: none;
    cursor: pointer;
    color: #0c5de9;
  }
  @media only screen and (min-width: 280px) and (max-width: 540px) {
    .main-div {
      margin: 0 5px 0 5px;
    }
  }
  .pagination-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 20px;
    padding: 20px 10px;
    flex-wrap: wrap;
  }
  .pagination-btn {
    min-width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
    background-color: white;
    color: #333;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0 12px;
  }
  .pagination-btn:hover:not(:disabled):not(.active) {
    background-color: #b2c225;
    color: #54575B;
    border-color: #b2c225;
  }
  .pagination-btn.active {
    background-color: #b2c225;
    color: #54575B;
    border-color: #b2c225;
    font-weight: 600;
  }
  .pagination-btn:disabled {
    background-color: #f5f5f5;
    color: #ccc;
    cursor: not-allowed;
    border-color: #e0e0e0;
  }
  .pagination-info {
    width: 100%;
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }
  </style>
